import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import env from '@beam-australia/react-env';

const ENVIRONMENT = env('ENVIRONMENT') ?? 'test';
const VERSION = env('VERSION') ?? '1.0.0';

const sessionsRate = ENVIRONMENT === 'prod' ? 100 : 10;

datadogRum.init({
  applicationId: 'fe316186-1365-470c-a69a-7b17ea4745b1',
  clientToken: 'pub776b66acd578e4416edad7342c9df493',
  site: 'datadoghq.com',
  service: 'taylor',
  env: ENVIRONMENT,
  version: VERSION,
  sessionSampleRate: sessionsRate,
  sessionReplaySampleRate: sessionsRate,
  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
  plugins: [reactPlugin({ router: false })],
  defaultPrivacyLevel: 'mask-user-input',
  allowedTracingUrls: [
    /^https:\/\/(tyson|apollo|api)(-[a-zA-Z0-9-]+)?(\.[a-zA-Z0-9-]+)*\.bosscat\.tech/,
    /^https:\/\/(tyson|apollo|api)(-[a-zA-Z0-9-]+)?(\.[a-zA-Z0-9-]+)*\.punchlistapi\.com/,
  ],
});

export { datadogRum };